import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import { FiSearch } from "react-icons/fi";
import Swal from "sweetalert2";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const MarksheetTypeSection = () => {
  const [getAllmarksheetData, setGetAllmarksheetData] = useState([]);
  const [updateId, setUpdateId] = useState("");
  const [marksheetData, setmarksheetData] = useState({
    shortName: "",
    fullName: "",
  });

  const [marksheetUpdateData, setmarksheetUpdateData] = useState({
    shortName: "",
    fullName: "",
  });

  const handleOnChange = (key, value) => {
    setmarksheetData((marksheetData) => ({
      ...marksheetData,
      [key]: value,
    }));
  };

  const handleUpdateOnChange = (key, value) => {
    setmarksheetUpdateData((marksheetUpdateData) => ({
      ...marksheetUpdateData,
      [key]: value,
    }));
  };

  const handleDelete = (id) => {
    Swal.fire({
      text: "Are you sure you won't be deleted?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const setDeletemarksheetData = await axios.delete(
            `api/admin/delete-marksheettype/${id}`
          );
          if (setDeletemarksheetData.data.ismarksheetTypeDeleted === true) {
            toast.success(setDeletemarksheetData.data.msg);
            handleGetmarksheetData();
          }
        } catch (error) {
          if (error.response.status === 400) {
            const message_400 = error?.response?.data?.message;
            toast.error(message_400);
          } else if (error.response.status === 401) {
            const message_401 = error?.response?.data?.message;
            toast.error(message_401);
          } else if (error.response.status === 404) {
            const message_404 = error?.response?.data?.message;
            console.log("message_404", message_404);
            toast.error(message_404);
          } else if (error.response.status === 500) {
            const message_500 = error?.response?.data?.message;
            toast.error(message_500);
          } else {
            toast.error("something went wrong");
          }
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("Cancelled");
      }
    });
  };
  const handleGetmarksheetData = async () => {
    try {
      const getMarksheet = await axios.get("api/admin/get-marksheettype");
      if (getMarksheet?.data?.ismarksheetTypeFound === true) {
        setGetAllmarksheetData(getMarksheet?.data?.data);
      }
    } catch (error) {
      if (error.response.status === 400) {
        const message_400 = error?.response?.data?.message;
        toast.error(message_400);
      } else if (error.response.status === 401) {
        const message_401 = error?.response?.data?.message;
        toast.error(message_401);
      } else if (error.response.status === 404) {
        const message_404 = error?.response?.data?.message;
        console.log("message_404", message_404);
        toast.error(message_404);
      } else if (error.response.status === 500) {
        const message_500 = error?.response?.data?.message;
        toast.error(message_500);
      } else {
        toast.error("something went wrong");
      }
    }
  };
  const handlePostmarksheetData = async (e) => {
    e.preventDefault();
    try {
      const setmarksheetData = await axios.post(
        "api/admin/add-marksheettype",
        marksheetData
      );
      if (setmarksheetData?.data?.ismarksheetTypeCreated === true) {
        toast.success(setmarksheetData?.data?.msg);
        window.location.reload();
        handleGetmarksheetData();
      }
      console.log("getMarksheet", setmarksheetData);
    } catch (error) {
      if (error.response.status === 400) {
        const message_400 = error?.response?.data?.message;
        toast.error(message_400);
      } else if (error.response.status === 401) {
        const message_401 = error?.response?.data?.message;
        toast.error(message_401);
      } else if (error.response.status === 404) {
        const message_404 = error?.response?.data?.message;
        console.log("message_404", message_404);
        toast.error(message_404);
      } else if (error.response.status === 500) {
        const message_500 = error?.response?.data?.message;
        toast.error(message_500);
      } else {
        toast.error("something went wrong");
      }
    }
  };

  const handleUpdatemarksheetData = async (e) => {
    e.preventDefault();
    try {
      const setUpdatemarksheetData = await axios.put(
        `api/admin/update-marksheettype/${updateId}`,
        marksheetUpdateData
      );
      if (setUpdatemarksheetData.data.ismarksheetTypeUpdated === true) {
        toast.success(setUpdatemarksheetData.data.msg);
        handleGetmarksheetData();
        window.location.reload();
      }
    } catch (error) {
      if (error.response.status === 400) {
        const message_400 = error?.response?.data?.message;
        toast.error(message_400);
      } else if (error.response.status === 401) {
        const message_401 = error?.response?.data?.message;
        toast.error(message_401);
      } else if (error.response.status === 404) {
        const message_404 = error?.response?.data?.message;
        console.log("message_404", message_404);
        toast.error(message_404);
      } else if (error.response.status === 500) {
        const message_500 = error?.response?.data?.message;
        toast.error(message_500);
      } else {
        toast.error("something went wrong");
      }
    }
  };
  console.log("updateId", updateId);
  useEffect(() => {
    handleGetmarksheetData();
  }, []);
  return (
    <Layout>
      <form className="d-flex mb-3 my-3">
        <div className="row w-100 justify-content-between g-3">
          <div className="col-lg-5 col-md-6 col-sm-12">
            <div className="input-group ">
              <input
                type="text"
                className="form-control"
                placeholder="Search Address"
                aria-label="Search"
                aria-describedby="button-addon2"
              />
              <button
                className="button-styles"
                type="button"
                id="button-addon2"
              >
                <FiSearch />
              </button>
            </div>
          </div>
        </div>
      </form>
      <button
        type="button"
        className="button-styles my-3"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        data-bs-whatever="@mdo"
      >
        <i class="fa-solid fa-plus mx-2"></i>
        Add Marksheet Type
      </button>
      <div className="table-responsive">
        <div>
          <div className="table-responsive table-box">
            <table className="table table-bordered">
              <thead>
                <tr className="table-head">
                  <th>Marksheet Id</th>
                  <th>Marksheet FullName</th>
                  <th>Marksheet ShortName</th>
                  <th>CreatedAt</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {getAllmarksheetData.map((nft, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{nft.fullName}</td>
                    <td>{nft.shortName}</td>
                    <td>{nft.createdAt}</td>

                    <td>
                      <button
                        className="button-styles"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#editcourse"
                        onClick={() => (
                          setmarksheetUpdateData({
                            shortName: nft.shortName,
                            fullName: nft.fullName,
                          }),
                          setUpdateId(nft._id)
                        )}
                      >
                        <i class="fa-solid fa-pen-to-square mx-2"></i>
                        Edit
                      </button>
                    </td>
                    <td>
                      <button
                        className="button-styles"
                        type="button"
                        onClick={() => handleDelete(nft._id)}
                      >
                        <i class="fa-solid fa-trash mx-2"></i>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/*Add modal form */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Marksheet Type
              </h5>
              <button
                type="button"
                className="btn-close cus-btn-close "
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form onSubmit={(e) => handlePostmarksheetData(e)}>
                <div className="mb-2">
                  <label htmlFor="recipient-name" className="col-form-label">
                    MarkSheet ShortName
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={marksheetData.shortName}
                    onChange={(e) =>
                      handleOnChange("shortName", e.target.value)
                    }
                  />
                </div>
                <div className="mb-2">
                  <label htmlFor="recipient-name" className="col-form-label">
                    MarkSheet FullName
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={marksheetData.fullName}
                    onChange={(e) => handleOnChange("fullName", e.target.value)}
                  />
                </div>
                <button className="button-styles" type="submit">
                  <i class="fa-solid fa-thumbs-up mx-2"></i>Save
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/*Edit  modal form */}
      <div
        className="modal fade"
        id="editcourse"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Marksheet Type
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form onSubmit={(e) => handleUpdatemarksheetData(e)}>
                <div className="mb-2">
                  <label htmlFor="recipient-name" className="col-form-label">
                    MarkSheet ShortName
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={marksheetUpdateData.shortName}
                    onChange={(e) =>
                      handleUpdateOnChange("shortName", e.target.value)
                    }
                  />
                </div>
                <div className="mb-2">
                  <label htmlFor="recipient-name" className="col-form-label">
                    MarkSheet FullName
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={marksheetUpdateData.fullName}
                    onChange={(e) =>
                      handleUpdateOnChange("fullName", e.target.value)
                    }
                  />
                </div>

                <button className="button-styles" type="submit">
                  <i class="fa-solid fa-thumbs-up mx-2"></i>Update
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" />
    </Layout>
  );
};
export default MarksheetTypeSection;
